export function shapeComponent(data = {}, isTrial, save) {
  const { forDefault } = data;
  const dataEnum = {
    forTrial: isTrial,
    forSave: save
  };
  let result = forDefault;

  Object.entries(dataEnum).forEach((entry) => {
    if (entry[1] && data[entry[0]]) {
      result = data[entry[0]];
    }
  });

  return result;
}
